import { render, staticRenderFns } from "./CreateOrUpdateCorporation.vue?vue&type=template&id=4298a158"
import script from "./CreateOrUpdateCorporation.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateCorporation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports